import useTransferListStore from '@aibees/shared/features/transfer-list/store/transfer-list-store';
import { useCallback } from 'react';

export function useResetTransferList() {
  const { config, setIncluded, setExcluded } = useTransferListStore();
  return useCallback(() => {
    if (config?.limit) {
      const includedDraft =
        config.items
          ?.filter((x) => !x.excluded)
          ?.slice(0, config.limit)
          .map((x) => x.id) ?? [];
      const excludedDraft =
        config.items
          ?.slice(config.limit, config.items?.length)
          .map((x) => x.id) ?? [];
      setIncluded(includedDraft);
      setExcluded(excludedDraft);
    } else {
      const includedDraft =
        config?.items?.filter((x) => !x.excluded).map((x) => x.id) ?? [];
      const excludedDraft =
        config?.items?.filter((x) => x.excluded).map((x) => x.id) ?? [];
      setIncluded(includedDraft);
      setExcluded(excludedDraft);
    }
  }, [config]);
}
